import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as errorUtils from '../../../modules/utility/global-utils';
import { LcaService } from '../../../services/lca.service';
import { Form, FormGroup, NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { ConfirmationService } from "primeng/api";
@Component({
  selector: 'app-notice-of-obligations',
  templateUrl: './notice-of-obligations.component.html',
  styleUrls: ['./notice-of-obligations.component.scss']
})
export class NoticeOfObligationsComponent implements OnInit, OnChanges {

  @Input() noticeOfObligations: FormGroup;
  @Input() employerInformation:any;
  maxDate = new Date();
  minDate: Date = new Date();
  selectedSignatures:any;
  listContact:any;  
  companyId:number;
  userEfileInfo:any;
  isDuplicateLCA: boolean = false;
  enableReadOnlyMode: boolean = false; 
  destroy$ = new Subject();  
  
  constructor(
    private lcaService: LcaService,
    private confirmationService: ConfirmationService,
    protected store: Store<any>) {}

    ngOnInit(): void {     
      this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';     
    }

    ngOnChanges(changes: SimpleChanges){
    
      if(changes.employerInformation.currentValue.companyName === 'null'){
        this.listContact = [];
        this.enableReadOnlyMode=false;
        this.noticeOfObligations.reset();
        this.listContact.push({
          id: 'Other',
          empName: 'Other'
        });
      } 
      else if(changes.employerInformation.currentValue.companyName)
      {
        this.listContact = [];
        this.getContactPersonList(changes.employerInformation.currentValue.companyName);
      }

         // console.log('this.userEfileInfo.lcaApplication.noticeOfObligations.employeeId');
  
      if(JSON.parse(localStorage.getItem('userEfileInfo'))){

        this.userEfileInfo = JSON.parse(localStorage.getItem('userEfileInfo')).noticeOfObligations;
        // this.lcaService.getContactPersonList(this.userEfileInfo.company.companyId).subscribe((res: any) => {
        //   if(res){
        //     this.noticeOfObligations.patchValue({
        //       authorisePerson: res[0].id
        //     });
        //             }
        // }); 
       //  console.log('this.userEfileInfo.lcaApplication.noticeOfObligations.employeeId',this.userEfileInfo);
        this.enableReadOnlyMode = true;
        if(this.userEfileInfo.employee.id)
        {
          this.noticeOfObligations.patchValue({
            authorisePerson:this.userEfileInfo.employee.id ,
            companyId: null,
            employeeId: this.userEfileInfo.employee.id,   
            firstName: this.userEfileInfo.firstName,
            middleName: this.userEfileInfo.middleName,
            lastName: this.userEfileInfo.lastName,
            designatedTitle: this.userEfileInfo.designatedTitle,
            cb:true,
            personType: "OBLIGATOR",
          });
        }
 else{
  this.noticeOfObligations.patchValue({
    authorisePerson:'Other' ,
    companyId: null,
    employeeId: this.userEfileInfo.employee.id,   
    firstName: this.userEfileInfo.firstName,
    middleName: this.userEfileInfo.middleName,
    lastName: this.userEfileInfo.lastName,
    designatedTitle: this.userEfileInfo.designatedTitle,
    cb:true,
    personType: "OBLIGATOR",
  });
 }
       
      }

    }

  getContactPersonList(id){
    this.companyId=id;
    this.lcaService.getContactPersonList(id).subscribe((res: any) => {
      if(res){
        this.listContact = res; 
        this.listContact.push({
          id: 'Other',
          empName: 'Other'
        });        
      }
    });    
  }

  onChangeContactPerson(id){
    this.noticeOfObligations.reset();
    let selectedContact = this.listContact.find(x => x.id === parseInt(id));
    if(id != 'Other'){
      this.enableReadOnlyMode = true;
      this.noticeOfObligations.patchValue({
        authorisePerson: selectedContact.id,
        companyId:this.companyId,
        employeeId:selectedContact.id ,    
        designatedTitle:selectedContact.designation,
        firstName: selectedContact.firstName,
        lastName: selectedContact.lastName,
        middleName: selectedContact.middleName,
        personType: "OBLIGATOR",  
      });  
  }

  if(id === 'Other' || id ===  "undefined" || id ===  null){

    this.enableReadOnlyMode = false;

    this.noticeOfObligations.reset();
   // console.log('companyIdcompanyId',this.companyId)
    this.noticeOfObligations.patchValue({
      authorisePerson:'Other' ,
      companyId:null

    });
}
}

getGlobalErrorMessages(error: string) {
  return errorUtils.errorMessages.get(error);
}

checkCheckBoxvalue(event){
  // console.log('event.checkedevent.checkedevent.checkedevent.checked',event.checked)
}

clearData() {
  // Clear any previous confirmation
  this.confirmationService.close();

  this.confirmationService.confirm({
    header: "Clear Data",
    icon: "pi pi-exclamation-triangle",
    rejectLabel: "Cancel",
    acceptLabel: "Yes, Clear Data",
    acceptButtonStyleClass: "btn-accept-clear",
    rejectButtonStyleClass: "btn-cancel-clear",
    message: `<div class="mb-4"> This will clear all the data from this section. </div>
              <div class="mb-4"> Are you sure, you want to clear data? </div>`,
    accept: () => {
      this.noticeOfObligations.reset({
        cb: false,
        personType: "OBLIGATOR"
      });
      this.confirmationService.close();
    },
    reject: () => {
      // Clear the confirmation dialog instance after rejection
     this.confirmationService.close();
   },
  });
}

ngOnDestroy(): void {
  this.destroy$.next();
  this.destroy$.complete();
}
}